export default "/8522fe2631ecefb1e3967be9883671f05392a386/78489dd5fe22b2b724f99f5861a7cee7.svg";